import {useEffect, useState} from "react";
import {BASE_URL} from "../../consts/BaseUrl";
import {Layer, Source} from "@vis.gl/react-maplibre";
import {useSelector} from "react-redux";
import httpReq from "../../services/httpReq";

const MapVideoTracks = ({ project, video }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [tracks, setTracks] = useState([]);

    const localStorageProjects = useSelector((state) => state.projects.openLocalStorage);
    const foundProject = (localStorageProjects && localStorageProjects.length > 0) ? localStorageProjects.find(p => p.id === project.id) : null;
    const localProject = { ...project, ...foundProject };
    const foundVideo = localProject.video ? localProject.video.find(v => v.id === localProject.id) : null;
    const localVideo = { ...video, ...foundVideo };

    useEffect(() => {
        if (isLoading) return;
        setIsLoading(true);
        httpReq('Video/GetTracks/'+localVideo.id, 'GET',null,true).then(res => {
            if (!res || res.responseAnyError) return;
            if (res.responseAnyError) return;
            const mappedTracks = [...res.responseData].map((track) => {
                const sourceID = 'tracks-source-' + track.id;
                const trackLayer = {
                    id: 'track-layer-' + track.id,
                    type: 'line',
                    source: sourceID,
                    'layout': {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    paint: {
                        'line-color': video.color,
                        'line-width': 2
                    }
                };
                const points = track.points.map((point) => {
                    return [point.longitude, point.latitude]
                });
                track.geoJSON = {
                    id: track.id,
                    type: 'Feature',
                    properties: {track: {...track}},
                    geometry: {
                        type: 'LineString',
                        coordinates: [...points]
                    },
                };
                track.layer = trackLayer
                return track;
            });
            setTracks(mappedTracks);
            setIsLoading(false);
        });

    }, [localStorageProjects])

    // console.log('tracks ', tracks);

    return (
        <>
            {
                (!!tracks && tracks.length > 0) && tracks.map((track) => {
                    return (
                        <Source
                            key={'key-' + track.layer.id}
                            id={track.layer.id}
                            type={'geojson'}
                            data={track.geoJSON}
                        >
                            <Layer {...track.layer} />
                        </Source>
                    )
                })
            }
        </>
    )
}
export default MapVideoTracks;